/**
 * configuration redux selectors
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


/**
 * select list of supported languages
 * @param state         current state
 * @returns [String]    list of supported language codes
 * @author Jens Gruschel
 */
export function selectSupportedLanguages(state) {
    return state.active.supportedLanguages || ["de", "en"];
}

/**
 * select translation for given value
 * @param state         current state
 * @param value         value
 * @param language      language code
 * @returns String      translation for given langauge
 * @author Jens Gruschel
 */
export function selectTranslation(state, value, language = null, fallback = true) {
    if (value instanceof Object) {
        if (Object.keys(value).length === 0) return ""; // objects empty by intention result in empty strings
        const result = value[language || state.active.defaultLanguage];
        if (result) return result;
        if (fallback && state.active.fallbackLanguages) {
            for (let alternativeLanguage of state.active.fallbackLanguages) {
                const alternativeTranslation = value[alternativeLanguage];
                if (alternativeTranslation) return alternativeTranslation;
            }
        }
        return undefined;
    }
    else {
        // no translation available
        return value;
    }
}

/**
 * select value for a given user settings field
 * @param state         current state
 * @param fieldId       field ID
 * @returns {*}         user settings value
 * @author Jens Gruschel
 */
export function selectUserSetting(state, fieldId) {
    return state.userSettings.fields[fieldId];
}

/**
 * select global base stylesheet
 * @param state         current state
 * @returns String      stylesheet (if existing)
 * @author Jens Gruschel
 */
export function selectBaseStylesheet(state) {
    const baseStyleItem = state.active.basestyle && state.active.basestyle[0];
    return baseStyleItem && baseStyleItem.fields && baseStyleItem.fields.definition;
}